import { render, staticRenderFns } from "./TerrainPublicAccess.vue?vue&type=template&id=5980b186&scoped=true"
import script from "./TerrainPublicAccess.vue?vue&type=script&lang=js"
export * from "./TerrainPublicAccess.vue?vue&type=script&lang=js"
import style0 from "./TerrainPublicAccess.vue?vue&type=style&index=0&id=5980b186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980b186",
  null
  
)

export default component.exports